//import * as feathers from '@feathersjs/feathers'
import feathers from '@feathersjs/client'
import reduxifyServices from 'feathers-redux' 

const query = require('qs')

const PROD_API = 'https://core-profile-api.misp-solutions.com'
const TEST_API = 'https://test.core-profile-api.misp-solutions.com'
const DEV_API = 'https://test.core-profile-api.misp-solutions.com'

const thisUrl = window.location.hostname.toLowerCase()

const app = feathers()
const restURL = (process.env.NODE_ENV === 'production') ? (thisUrl.includes('test') || thisUrl.includes('-dev') ? TEST_API : PROD_API) : DEV_API
const restClient = feathers.rest(restURL)

restClient.Base.prototype.makeUrl = function (params, id) {
	params = params || {}
	let url = this.base

	if (typeof id !== 'undefined' && id !== null) {
		url += `/${encodeURIComponent(id)}`
	}

	if (Object.keys(params).length !== 0) {
		const queryString = query.stringify(params, { strictNullHandling: true })

		url += `?${queryString}`
	}

	return url
}

app.configure(restClient.fetch(window.fetch))

app.configure(feathers.authentication({
	storage: window.localStorage
}))

export default app
export const services = reduxifyServices(app, ['users', 'accounts'])


// WEBPACK FOOTER //
// ./src/api/index.js